import script from "./TrainingMain.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainingMain.vue?vue&type=script&setup=true&lang=js"

import "./TrainingMain.vue?vue&type=style&index=0&id=7e5abad7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e5abad7"]])

export default __exports__